import React from 'react';
import { BookOpen, ShoppingCart, Check } from 'lucide-react';
const takeaways = ['How spec-driven development reshapes the software lifecycle', 'Designing enterprise architecture for autonomous, intelligent agents', 'Governance, security, and traceability in an AI-assisted SDLC', 'Practical patterns for teams adopting AI without losing control'];
export function BookSection() {
  return <section id="book" className="py-24 bg-[#0d1321] px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-56" data-mp="3byrdb2w4rk63">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-57" data-mp="37us3f35cvjlp">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" data-id="element-58" data-mp="32w8fix77bxqp"></div>
        <div className="absolute -bottom-20 left-0 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" data-id="element-59" data-mp="2xygmfzutm5kx"></div>
      </div>

      <div className="max-w-6xl mx-auto relative" data-id="element-60" data-mp="1rg9xi3u1q1dc">
        <div className="text-center mb-16" data-id="element-61" data-mp="1mii6dc186ja7">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-cyan-500/20 rounded-2xl mb-4 border border-cyan-500/30 backdrop-blur-sm glow-cyan" data-id="element-62" data-mp="1mlmg0oxgm789">
            <BookOpen className="h-8 w-8 text-cyan-400" data-id="element-63" data-mp="68gdr7jibs5g" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-64" data-mp="3ofw3jd6m8smm">
            Published Book
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full" data-id="element-65" data-mp="3tded95sgjbvo"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-66" data-mp="3eo03vxovsuga">
          {/* Cover */}
          <div className="flex justify-center lg:justify-end" data-id="element-67" data-mp="3jhul8uh0kxc7">
            <div className="relative max-w-xs w-full" data-id="element-68" data-mp="35po2d0mh8c92">
              <div className="absolute inset-0 bg-cyan-500 rounded-xl transform translate-x-4 translate-y-4 opacity-20 blur-md" data-id="element-69" data-mp="35n1v723hzyrd"></div>
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/d68ff255-7e9c-429b-b2ca-bc2cc2ac78ea.jpg" alt="Cover of AI-SDLC And The New Enterprise Architecture Approach by Arthur Miller" className="relative z-10 w-full h-auto rounded-xl border border-white/10 shadow-2xl glow-cyan" data-id="element-70" data-mp="2vq6zss2iuehb" />
            </div>
          </div>

          {/* Details */}
          <div className="text-center lg:text-left" data-id="element-71" data-mp="27w58rahhhmg1">
            <span className="inline-block px-4 py-1 bg-cyan-500/20 text-cyan-300 text-xs font-bold tracking-wider uppercase rounded-full mb-6 border border-cyan-500/30" data-id="element-72" data-mp="22wajtch9r6xm">
              Available on Amazon
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 leading-tight" data-id="element-73" data-mp="2vkognowmfx7l">
              AI-SDLC And The New Enterprise Architecture Approach
            </h3>
            <p className="text-lg bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent font-medium mb-6" data-id="element-74" data-mp="2lms6azbid6aj">
              Spec-Driven Development for the Age of Intelligent Agents
            </p>
            <p className="text-slate-400 leading-relaxed mb-8" data-id="element-75" data-mp="1a73k4a62wbas">
              A practical framework for engineering and architecture leaders
              navigating the shift to AI-assisted delivery — how specifications
              become the source of truth, and how enterprise architecture must
              evolve when intelligent agents write, test, and ship software.
            </p>

            <ul className="space-y-3 mb-10 text-left" data-id="element-76" data-mp="4e71r1a3fucv">
              {takeaways.map(item => <li key={item} className="flex items-start gap-3" data-id="element-77" data-mp="9dtnjz3zmixa">
                  <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-cyan-500/15 border border-cyan-500/30 flex items-center justify-center" data-id="element-78" data-mp="9fmk2lkvzmrk">
                    <Check className="h-3 w-3 text-cyan-400" data-id="element-79" data-mp="idyhp7k67kti" />
                  </span>
                  <span className="text-slate-400" data-id="element-80" data-mp="nduotfo5zsda">{item}</span>
                </li>)}
            </ul>

            <a href="https://a.co/d/01eE6XoT" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-3.5 bg-cyan-500 text-black font-semibold rounded-lg hover:bg-cyan-400 transition-colors shadow-lg glow-cyan" data-id="element-81" data-mp="2k6mqrxjhx2h7">
              <ShoppingCart className="h-5 w-5" data-id="element-82" data-mp="egst8ygdpl1i" />
              Buy on Amazon
            </a>
          </div>
        </div>
      </div>
    </section>;
}